import { APP_CONFIG } from "../constants";
import { apiClient } from "./apiClient";

export interface OrientacaoProducaoImagem {
  id: number;
  ordem: number;
  url: string;
}

export interface OrientacaoProducaoData {
  texto: string;
  imagens: OrientacaoProducaoImagem[];
}

/** @deprecated use OrientacaoProducaoData */
export type OrientacaoSemanalData = OrientacaoProducaoData;
/** @deprecated use OrientacaoProducaoImagem */
export type OrientacaoSemanalImagem = OrientacaoProducaoImagem;

export interface UndMedidaOption {
  id: number;
  nome: string;
}

export interface UndMedida extends UndMedidaOption {
  ativo: boolean;
}

export interface ItemProducao {
  id: number;
  lojaId: number;
  descricao: string;
  pesoPadrao: string;
  undMedidaId?: number | null;
  undMedidaNome?: string | null;
  undMedidaIdBase?: number | null;
  undMedidaBaseNome?: string | null;
  ordem?: number;
  ativo: boolean;
  origemProducao?: "LOCAL" | "OUTRA_UNIDADE";
  naoUsaTimer?: boolean;
  setorIds?: number[];
  setorPercentuais?: Record<number, number>;
  setores?: { id: number; nome: string }[];
  podeExcluir?: boolean;
}

export interface ItensProducaoResponse {
  unds: UndMedidaOption[];
  itens: ItemProducao[];
}

export interface BaseSemanalCelulaDia {
  quantidadeBase: string;
  undMedidaId?: number | null;
  sugestaoAnterior?: string;
  preenchidoDaSemanaAnterior?: boolean;
}

export type TipoDiaFuncionamento = "fechado" | "sobra" | "producao";

export interface BaseSemanalColunaDia {
  diaSemana: number;
  label: string;
  labelCompleto: string;
  dataDia?: string;
  ehHoje: boolean;
  tipoDia?: TipoDiaFuncionamento;
  permiteEdicao: boolean;
  colunaCompleta?: boolean;
}

export interface BaseSemanalItemSetor {
  id: number;
  nome: string;
  ordem?: number;
}

export interface BaseSemanalItemMatriz {
  itemId: number;
  descricao: string;
  pesoPadrao: string;
  undMedidaIdItem?: number | null;
  undMedidaIdBaseItem?: number | null;
  undMedidaId?: number | null;
  setores?: BaseSemanalItemSetor[];
  basesPorDia: Record<number, BaseSemanalCelulaDia>;
}

/** @deprecated visão de um único dia */
export interface BaseSemanalItem {
  itemId: number;
  descricao: string;
  pesoPadrao: string;
  undMedidaIdItem?: number | null;
  undMedidaIdBaseItem?: number | null;
  quantidadeBase: string;
  undMedidaId?: number | null;
  sugestaoAnterior: string;
  sugestaoUndMedidaIdAnterior?: number | null;
  preenchidoDaSemanaAnterior?: boolean;
  preenchidoUndDaSemanaAnterior?: boolean;
}

export interface BaseSemanalResponse {
  matriz?: boolean;
  diaSemana?: number;
  dataSegunda: string;
  unds?: UndMedidaOption[];
  segundaAtual?: string;
  baseConfirmada: boolean;
  ehSegundaHoje?: boolean;
  semanaCorrente?: boolean;
  baseVaziaNoBanco?: boolean;
  permiteEdicao?: boolean;
  permiteConfirmacao?: boolean;
  /** @deprecated use permiteEdicao */
  permiteCadastro?: boolean;
  orientacao?: OrientacaoProducaoData;
  permiteEditarOrientacao?: boolean;
  diasColunas?: BaseSemanalColunaDia[];
  diasTrabalho?: number[];
  itens: BaseSemanalItemMatriz[];
}

export interface FuncionamentoDiaProducao {
  diaSemana: number;
  label: string;
  labelCurto: string;
  tipoDia: TipoDiaFuncionamento;
  produzEmBirigui?: boolean;
  turnoDiaInicio: string;
  turnoDiaTermino: string;
  turnoNoiteInicio: string;
  turnoNoiteTermino: string;
}

export interface FuncionamentoBaseProducaoResponse {
  lojaId: number;
  configuraProducaoEmBirigui?: boolean;
  dias: FuncionamentoDiaProducao[];
}

export interface BaseSemanalAlertaResponse {
  exibirAlerta: boolean;
  ehSegundaHoje: boolean;
  baseConfirmada: boolean;
  dataSegunda: string;
  mensagem: string;
}

export interface BaseSemanalHistoricoSemana {
  dataSegunda: string;
  label: string;
}

export interface BaseSemanalHistoricoResponse {
  lojaId: number;
  semanas: BaseSemanalHistoricoSemana[];
}

export interface FichaDiariaItem {
  itemId: number;
  descricao: string;
  pesoPadrao: string;
  base: string;
  baseValor?: string;
  undMedidaIdBase?: number | null;
  sobra: string;
  undMedidaIdSobra?: number | null;
  sobraExibicao?: string;
  producao: string;
  undMedidaIdProducao?: number | null;
  producaoExibicao?: string;
  producaoChecada: boolean;
  naoProduzidoPelaUnidade?: boolean;
  justificativaNaoProduziu?: string;
  sugestaoProducao: string;
  sugestaoUndMedidaIdProducao?: number | null;
  observacaoSobra: string;
  observacaoProducao: string;
  sobraReferencia?: string;
  sobraReferenciaExibicao?: string;
  undMedidaIdSobraReferencia?: number | null;
  naoUsaTimer?: boolean;
  cronometragem?: CronometragemItem | null;
  unidadeLabel?: string | null;
  itemIdOutraLoja?: number;
  lojaIdOutra?: number;
  somenteSobraOutraUnidade?: boolean;
  totalLinhasGrupo?: number;
  indexNoGrupo?: number;
  setores?: {
    id: number;
    nome: string;
    ordem: number;
    percentual?: number;
    producao?: string | null;
    undMedidaIdProducao?: number | null;
    producaoChecada?: boolean;
    naoProduzidoPelaUnidade?: boolean;
    justificativaNaoProduziu?: string | null;
    observacaoProducao?: string | null;
    cronometragem?: CronometragemItem | null;
  }[];
}

export type TurnoProducao = "dia" | "noite";

export interface SetorProducao {
  id: number;
  lojaId: number;
  nome: string;
  ordem: number;
  ativo: boolean;
}

export interface PausaFichaItem {
  itemId: number;
  itemDescricao: string;
  usuarioNome: string;
  pausadoEm: string;
  retomadoEm: string | null;
  justificativa: string | null;
}

export interface PausaPeriodoItem extends PausaFichaItem {
  dataFicha: string;
}

export interface CronometragemItem {
  status: "RUNNING" | "PAUSED" | "FINISHED" | string;
  startedAt?: string | null;
  pausedAt?: string | null;
  finishedAt?: string | null;
  runningSince?: string | null;
  tempoLiquidoMs: number;
  tempoFormatado: string;
  tempoPausaManualMs?: number;
  tempoPausaFormatado?: string;
  pausaAutomatica?: boolean;
  userId?: number;
  userNome?: string | null;
}

export interface AssinaturaSetorFicha {
  setorId: number;
  setorNome: string;
  assinado: boolean;
  liberadoDev?: boolean;
  userId?: number | null;
  userNome?: string | null;
  dataAssinatura?: string | null;
  imagemAssinatura?: string | null;
}

export interface ProdutorOnlineSetor {
  userId: number;
  nome: string;
  status: "RUNNING" | "PAUSED";
}

export interface ResumoSetorFicha {
  setorId: number;
  setorNome: string;
  conferenciaAssinada: boolean;
  conferenciaNome?: string | null;
  conferenciaData?: string | null;
  producaoAssinada: boolean;
  producaoNome?: string | null;
  producaoData?: string | null;
  tempoTotalMs: number;
  tempoFormatado: string;
  itensTotal?: number;
  itensResolvidos?: number;
  produtoresOnline?: ProdutorOnlineSetor[];
  producaoImagem?: string | null;
}

export interface FichaDiariaResponse {
  dataFicha: string;
  dataSegunda?: string;
  tipoDia?: TipoDiaFuncionamento;
  /** @deprecated use tipoDia === 'producao' */
  funciona?: boolean;
  avisoDiaFechado?: string;
  diaSobraReferencia?: number | null;
  diaSobraReferenciaLabel?: string | null;
  dataSobraReferencia?: string | null;
  avisoSobraReferencia?: string;
  avisoDiaSemProducao?: string;
  horariosTurno?: {
    turnoDiaInicio: string;
    turnoDiaTermino: string;
    turnoNoiteInicio: string;
    turnoNoiteTermino: string;
  };
  labelsTurno?: { dia: string; noite: string };
  /** 1=seg … 7=dom — dia da ficha para buscar a base correspondente. */
  diaSemana?: number;
  diaSemanaLabel?: string;
  baseDiaPreenchida?: boolean;
  baseReferenciaSemanaAnterior?: boolean;
  avisoBaseDia?: string;
  unds?: UndMedidaOption[];
  baseConfirmada: boolean;
  /** Algum campo editável no turno/data atual. */
  permiteEdicao?: boolean;
  turnoAtual?: TurnoProducao;
  dataFichaPadrao?: string;
  dataHoje?: string;
  /** Admin na ficha operacional atual: ajuste de valores e UND. */
  podeAjustarFicha?: boolean;
  /** Local ou perfil desenvolvedor: pode forçar DIA/NOITE na ficha. */
  podeSimularTurno?: boolean;
  podeEditarBase?: boolean;
  podeAlterarUnd?: boolean;
  podeEditarSobra?: boolean;
  podeEditarProducao?: boolean;
  motivoBloqueioProducao?: string | null;
  podeEditarObservacao?: boolean;
  podeAssinarProducao?: boolean;
  podeAssinarProducaoTotal?: boolean;
  podeAssinarConferencia?: boolean;
  mensagem?: string;
  avisoItensSemSetor?: string;
  exigeSetor?: boolean;
  setoresDisponiveis?: { id: number; nome: string; ordem: number }[];
  setorAtual?: { id: number; nome: string; ordem: number } | null;
  assinaturasSetores?: AssinaturaSetorFicha[];
  resumoSetores?: ResumoSetorFicha[];
  pendenciasProducaoTotal?: {
    setoresSemAssinatura: { setorId: number; setorNome: string }[];
    itensPendentes: { setorNome: string; descricao: string }[];
  };
  /** Datas anteriores: ficha unificada agrupada por setor (consulta/impressão). */
  fichaConsultaPorSetor?: boolean;
  /** Gestão: ficha inteira, só consulta, atualizada em tempo real no cliente. */
  visaoFichaCompleta?: boolean;
  itensSemSetorCount?: number;
  /** false quando a ficha ainda não foi salva/assinada no banco (só consulta). */
  fichaPersistida?: boolean;
  ficha?: {
    id: number | null;
    assinadoProducao: boolean;
    userProducaoId: number | null;
    userProducaoNome: string | null;
    dataAssinaturaProducao: string | null;
    imagemAssinaturaProducao?: string | null;
    assinadoConfere: boolean;
    userConfereId: number | null;
    userConfereNome: string | null;
    dataAssinaturaConf: string | null;
    justificativaSemSobra?: string | null;
    ajustadoAdminConferencia?: boolean;
    ajustadoAdminProducao?: boolean;
    liberadoDevConferencia?: boolean;
    liberadoDevProducao?: boolean;
    edicaoLiberadaAtiva?: boolean;
    edicaoLiberadaAte?: string | null;
    edicaoLiberadaPorNome?: string | null;
    edicaoLiberadaEscopoLoja?: boolean;
    imagemAssinaturaConf?: string | null;
  };
  itens?: FichaDiariaItem[];
  orientacao?: OrientacaoProducaoData;
  podeImprimir?: boolean;
  bloqueada?: boolean;
  edicaoLiberadaAtiva?: boolean;
  edicaoLiberadaAte?: string | null;
  edicaoLiberadaPorNome?: string | null;
  edicaoLiberadaEscopoLoja?: boolean;
}

export type AgrupamentoRelatorioConsumo = "dia" | "semana" | "mes";

export interface PainelSobrasDia {
  dataISO: string;
  diaSemana: number;
  diaSemanaLabel: string;
  tipoDia: TipoDiaFuncionamento;
  fichaAssinada: boolean;
  justificativaSemSobra?: string | null;
}

export interface PainelSobrasCelula {
  dataISO: string;
  quantidade: string | null;
  undNome: string;
  observacao?: string | null;
}

export interface PainelSobrasItem {
  itemId: number;
  descricao: string;
  origemProducao: "LOCAL" | "OUTRA_UNIDADE";
  undNome: string;
  celulas: PainelSobrasCelula[];
}

export interface PainelSobrasResponse {
  lojaId: number;
  lojaNome: string;
  dataInicio: string;
  dataFim: string;
  dias: PainelSobrasDia[];
  itens: PainelSobrasItem[];
}

export interface RelatorioConsumoLinha {
  periodoKey: string;
  periodoLabel: string;
  dataFicha?: string;
  diaSemana?: number;
  diaSemanaLabel?: string;
  tipoDia?: TipoDiaFuncionamento;
  itemId: number;
  descricao: string;
  undNome: string;
  base: string | null;
  estoqueInicial: number | null;
  producao: number | null;
  sobra: number | null;
  consumo: number | null;
  diasNoGrupo?: number;
  fichaAssinada?: boolean;
}

export type SituacaoEstoqueInsight = "sobra" | "zerou" | "faltou";

export interface RelatorioConsumoInsight {
  itemId: number;
  descricao: string;
  undNome: string;
  estoqueInicialPeriodo: number | null;
  producaoTotal: number;
  consumoTotal: number;
  sobraTotal: number;
  sobraFinal: number | null;
  saldoFinal: number;
  situacaoEstoque: SituacaoEstoqueInsight;
  diasComSobra: number;
  diasZerouSobra: number;
  diasComConsumo: number;
  consumoMedioDia: number;
  sugestaoCompraDia: number;
  sugestaoCompraPeriodo: number;
}

export interface RelatorioConsumoMediaDiaSemana {
  diaSemana: number;
  diaSemanaLabel: string;
  tipoDia: TipoDiaFuncionamento;
  itemId: number;
  descricao: string;
  undNome: string;
  ocorrencias: number;
  consumoTotal: number;
  consumoMedio: number;
  producaoTotal: number;
  producaoMedia: number;
  sobraTotal: number;
  sobraMedia: number;
  sugestaoCompra: number;
}

export interface RelatorioConsumoResumoDiaSemana {
  diaSemana: number;
  diaSemanaLabel: string;
  tipoDia: TipoDiaFuncionamento;
  ocorrencias: number;
  diasComConsumo: number;
  itemDestaque?: {
    itemId: number;
    descricao: string;
    undNome: string;
    consumoMedio: number;
  };
}

export interface RelatorioConsumoResponse {
  lojaId: number;
  dataInicio: string;
  dataFim: string;
  agrupamento: AgrupamentoRelatorioConsumo;
  margemCompraPercent: number;
  diasAbertosNoPeriodo: number;
  linhas: RelatorioConsumoLinha[];
  insights: RelatorioConsumoInsight[];
  mediasPorDiaSemana: RelatorioConsumoMediaDiaSemana[];
  resumoDiaSemana: RelatorioConsumoResumoDiaSemana[];
}

export interface RelatorioTemposProducaoUnd {
  undNome: string;
  total: number;
  totalFormatado: string;
}

export interface RelatorioTemposProducaoOrigem {
  lojaId: number;
  lojaNome: string;
  producaoPorUnd: RelatorioTemposProducaoUnd[];
}

export interface RelatorioTemposLinha {
  periodoKey: string;
  periodoLabel: string;
  dataFicha?: string;
  diaSemana?: number;
  diaSemanaLabel?: string;
  itemId: number;
  descricao: string;
  undNome?: string;
  setorId: number;
  setorNome: string;
  userId?: number;
  userNome?: string;
  tempoTotalMs: number;
  tempoFormatado: string;
  ocorrencias: number;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  tempoMinMs?: number;
  tempoMinFormatado?: string;
  tempoMaxMs?: number;
  tempoMaxFormatado?: string;
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
}

export interface RelatorioTemposUsuarioFicha {
  dataFicha: string;
  tempoTotalMs: number;
  tempoFormatado: string;
  ocorrencias: number;
  tempoMedioMs?: number;
  tempoMedioFormatado?: string;
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
  producaoPorUnd?: RelatorioTemposProducaoUnd[];
}

export interface RelatorioTemposUsuarioItem {
  itemId: number;
  descricao: string;
  ocorrencias: number;
  tempoTotalMs: number;
  tempoFormatado: string;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  producao: number | null;
  producaoFormatada: string | null;
  undNome: string;
  ritmoPorHora: number | null;
  ritmoFormatado: string | null;
  setorIds?: number[];
  setores?: string[];
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
}

export interface RelatorioTemposUsuario {
  userId: number;
  userNome: string;
  tempoTotalMs: number;
  tempoFormatado: string;
  ocorrencias: number;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  tempoMinMs?: number;
  tempoMinFormatado?: string;
  tempoMaxMs?: number;
  tempoMaxFormatado?: string;
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
  itensDistintos?: number;
  setoresDistintos?: number;
  producaoPorUnd?: RelatorioTemposProducaoUnd[];
  porFicha?: RelatorioTemposUsuarioFicha[];
  porItem?: RelatorioTemposUsuarioItem[];
  porSetor?: Array<{
    setorId: number;
    setorNome: string;
    ocorrencias: number;
    tempoTotalMs: number;
    tempoFormatado: string;
    tempoMedioMs: number;
    tempoMedioFormatado: string;
    tempoPausaMs?: number;
    tempoPausaFormatado?: string;
  }>;
}

export interface RelatorioTemposItem {
  itemId: number;
  descricao: string;
  undNome: string;
  setores: string[];
  ocorrencias: number;
  tempoTotalMs: number;
  tempoFormatado: string;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  tempoMinMs: number;
  tempoMinFormatado: string;
  tempoMaxMs: number;
  tempoMaxFormatado: string;
  producao: number | null;
  producaoFormatada: string | null;
  producaoPorOrigem?: RelatorioTemposProducaoOrigem[];
  ritmoPorHora: number | null;
  ritmoFormatado: string | null;
  usuariosDistintos: number;
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
}

export interface RelatorioTemposSetor {
  setorId: number;
  setorNome: string;
  ocorrencias: number;
  tempoTotalMs: number;
  tempoFormatado: string;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  tempoMinMs: number;
  tempoMinFormatado: string;
  tempoMaxMs: number;
  tempoMaxFormatado: string;
  itensDistintos: number;
  usuariosDistintos: number;
  producaoPorUnd: RelatorioTemposProducaoUnd[];
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
  itensEsperados?: number;
  itensEntregues?: number;
  percentualEntrega?: number;
  percentualEntregaFormatado?: string;
}

export interface RelatorioTemposEntregaPeriodo {
  periodoKey: string;
  periodoLabel: string;
  agrupamento: "semana" | "quinzena" | "mes" | "periodo";
  itensEsperados: number;
  itensEntregues: number;
  percentual: number;
  percentualFormatado: string;
}

export interface RelatorioTemposSetorEntrega {
  setorId: number;
  setorNome: string;
  periodo: RelatorioTemposEntregaPeriodo;
  porSemana: RelatorioTemposEntregaPeriodo[];
  porQuinzena: RelatorioTemposEntregaPeriodo[];
  porMes: RelatorioTemposEntregaPeriodo[];
}

export interface RelatorioTemposRankingLinha {
  posicao: number;
  id: number;
  nome: string;
  ocorrencias: number;
  valor: number;
  valorFormatado: string;
  detalhe?: string;
  undNome?: string;
}

export interface RelatorioTemposInsight {
  id: string;
  tom: "info" | "good" | "watch";
  titulo: string;
  texto: string;
}

export interface RelatorioTemposResumo {
  cronometragensEncerradas: number;
  itensDistintos: number;
  usuariosDistintos: number;
  setoresDistintos: number;
  fichasComTempo: number;
  tempoTotalMs: number;
  tempoTotalFormatado: string;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  tempoPausaMs?: number;
  tempoPausaFormatado?: string;
  itensProduzidosSemCronometro: number;
  itensNaoProduzidosUnidade: number;
  producaoPorUnd: RelatorioTemposProducaoUnd[];
  producaoCronometradaPorUnd?: RelatorioTemposProducaoUnd[];
  producaoPorOrigem?: RelatorioTemposProducaoOrigem[];
}

export type StatusAssinaturaMeta =
  | "no_prazo"
  | "atrasado"
  | "nao_assinado"
  | "pendente";

export interface RelatorioAssinaturaLinha {
  dataFicha: string;
  diaSemana: number;
  diaSemanaLabel: string;
  setorId: number;
  setorNome: string;
  horaLimite: string;
  status: StatusAssinaturaMeta;
  assinado: boolean;
  userId?: number;
  userNome?: string;
  dataAssinatura?: string;
  horarioAssinatura?: string;
  minutosAposLimite?: number | null;
  minutosAposLimiteFormatado?: string | null;
  setorCompleto: boolean;
  itensResolvidos: number;
  itensTotal: number;
  fichaProducaoCompleta: boolean;
}

export interface RelatorioAssinaturaAgregado {
  periodoKey: string;
  periodoLabel: string;
  esperados: number;
  assinados: number;
  noPrazo: number;
  atrasados: number;
  naoAssinados: number;
  pendentes: number;
  incompletos: number;
  percentualNoPrazo: number | null;
  percentualNoPrazoFormatado: string;
}

export interface RelatorioAssinaturaSetor extends RelatorioAssinaturaAgregado {
  setorId: number;
  setorNome: string;
}

export interface RelatorioAssinaturaUsuario {
  userId: number;
  userNome: string;
  assinados: number;
  noPrazo: number;
  atrasados: number;
  incompletos: number;
  percentualNoPrazo: number | null;
  percentualNoPrazoFormatado: string;
  atrasoMedioMin: number | null;
  atrasoMedioFormatado: string | null;
}

export interface RelatorioAssinaturasProducaoResponse {
  lojaId: number;
  lojaNome: string;
  dataInicio: string;
  dataFim: string;
  horaLimite: string;
  horaLimiteSabado: string;
  usaSetores: boolean;
  resumo: RelatorioAssinaturaAgregado;
  porDia: RelatorioAssinaturaAgregado[];
  porSemana: RelatorioAssinaturaAgregado[];
  porSetor: RelatorioAssinaturaSetor[];
  porUsuario: RelatorioAssinaturaUsuario[];
  linhas: RelatorioAssinaturaLinha[];
}

export interface RelatorioTemposResponse {
  lojaId: number;
  dataInicio: string;
  dataFim: string;
  agrupamento: AgrupamentoRelatorioConsumo;
  resumo?: RelatorioTemposResumo;
  insights?: RelatorioTemposInsight[];
  rankings?: {
    usuariosMaisRapidos: RelatorioTemposRankingLinha[];
    usuariosMaisProdutivos: RelatorioTemposRankingLinha[];
    usuariosMelhorRitmo: RelatorioTemposRankingLinha[];
    itensMaisRapidos: RelatorioTemposRankingLinha[];
    itensMaisLentos: RelatorioTemposRankingLinha[];
    itensMaiorProducao: RelatorioTemposRankingLinha[];
    setoresMaisRapidos: RelatorioTemposRankingLinha[];
    setoresMaiorVolume: RelatorioTemposRankingLinha[];
    setoresMaiorEntrega?: RelatorioTemposRankingLinha[];
    usuariosMaisPausados?: RelatorioTemposRankingLinha[];
    itensMaisPausados?: RelatorioTemposRankingLinha[];
  };
  linhas: RelatorioTemposLinha[];
  porItem?: RelatorioTemposItem[];
  porSetor?: RelatorioTemposSetor[];
  porUsuario: RelatorioTemposUsuario[];
  entregaPorSetor?: RelatorioTemposSetorEntrega[];
}

export interface RelatorioEquipeUsuario {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  roleId: number;
  roleNome: string;
  isConferenteBase: boolean;
}

export interface FichaDiariaUsuarioSetor {
  id: number;
  nome: string;
  funcao: string;
}

export interface FichaDiariaUsuariosSetorResponse {
  setorId: number;
  setorNome: string;
  usuarios: FichaDiariaUsuarioSetor[];
}

export interface RelatorioEquipeSetor {
  setorId: number;
  nome: string;
  ordem: number;
  ativo: boolean;
  usuarios: RelatorioEquipeUsuario[];
}

export interface RelatorioEquipeResponse {
  lojaId: number;
  lojaNome: string;
  setores: RelatorioEquipeSetor[];
  conferentes: RelatorioEquipeUsuario[];
  resumo: {
    setoresAtivos: number;
    usuariosProducaoDistintos: number;
    conferentes: number;
  };
}

export interface ProducaoUndRanking {
  undNome: string;
  total: number;
  totalFormatado: string;
}

export interface RankingDiaFichaUsuario {
  usuarioId: number;
  nome: string;
  itensEncerrados: number;
  tempoTotalMs: number;
  tempoMedioMs: number;
  tempoMedioFormatado: string;
  emProducao: boolean;
  producaoKg?: number;
  producaoKgFormatado: string;
  producaoQuantidade?: number;
  producaoPorUnd?: ProducaoUndRanking[];
  pontuacaoQtd: number;
  pontuacaoTempo: number;
  pontuacao: number;
}

export interface RankingDiaFichaResponse {
  lojaId: number | null;
  lojaNome: string | null;
  dataFicha: string;
  criterio: string;
  ranking: RankingDiaFichaUsuario[];
  resumo: {
    itensEncerrados: number;
    emProducao: number;
    tempoMedioMs: number;
    tempoMedioFormatado: string;
    usuarios: number;
    producaoKg: number;
    producaoKgFormatado: string;
    producaoPorUnd?: ProducaoUndRanking[];
  };
}

export interface AssinaturaTvSetor {
  assinado: boolean;
  nome: string | null;
  data: string | null;
  papel?: string | null;
  responsaveis?: string[] | null;
}

export interface ProgressoItensTv {
  itensTotal: number;
  itensResolvidos: number;
  pct: number;
}

export interface SetorProgressoTv extends ProgressoItensTv {
  setorId: number;
  setorNome: string;
  producao: AssinaturaTvSetor;
}

export interface LojaProgressoTv {
  lojaId: number;
  lojaNome: string;
  geral: ProgressoItensTv;
  conferencia: AssinaturaTvSetor;
  producaoTotal: AssinaturaTvSetor;
  setores: SetorProgressoTv[];
}

export interface RankingSetoresResponse {
  lojaId: number | null;
  lojaNome: string | null;
  dataFicha: string;
  geral: ProgressoItensTv;
  conferencia: AssinaturaTvSetor | null;
  producaoTotal: AssinaturaTvSetor | null;
  setores: SetorProgressoTv[];
  lojas: LojaProgressoTv[];
}

const FICHA_NO_STORE = { cache: "no-store" as const };

function urlFichaSemCache(path: string): string {
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}_=${Date.now()}`;
}

export const controleProducaoService = {
  listUndMedidas: (): Promise<UndMedida[]> =>
    apiClient.get("/controle-producao/und-medida"),

  createUndMedida: (payload: {
    nome: string;
    ativo?: boolean;
  }): Promise<UndMedida> =>
    apiClient.post("/controle-producao/und-medida", payload),

  updateUndMedida: (
    id: number,
    payload: { nome: string; ativo?: boolean }
  ): Promise<UndMedida> =>
    apiClient.put(`/controle-producao/und-medida/${id}`, payload),

  listItems: (lojaId?: number): Promise<ItensProducaoResponse> =>
    apiClient.get(
      `/controle-producao/itens${lojaId ? `?lojaId=${lojaId}` : ""}`
    ),

  createItem: (payload: {
    descricao: string;
    pesoPadrao: string;
    undMedidaId: number;
    undMedidaIdBase: number;
    ativo: boolean;
    lojaId?: number;
    aplicarEmTodasLojas?: boolean;
    setorIds?: number[];
    setorPercentuais?: Record<number, number>;
    origemProducao?: "LOCAL" | "OUTRA_UNIDADE";
    naoUsaTimer?: boolean;
  }): Promise<ItemProducao> =>
    apiClient.post("/controle-producao/itens", payload),

  updateItem: (
    id: number,
    payload: {
      descricao: string;
      pesoPadrao: string;
      undMedidaId: number;
      undMedidaIdBase: number;
      ativo: boolean;
      lojaId?: number;
      setorIds?: number[];
      setorPercentuais?: Record<number, number>;
      origemProducao?: "LOCAL" | "OUTRA_UNIDADE";
      naoUsaTimer?: boolean;
    }
  ): Promise<ItemProducao> =>
    apiClient.put(`/controle-producao/itens/${id}`, payload),

  deleteItem: (id: number, lojaId?: number): Promise<void> =>
    apiClient.delete(
      `/controle-producao/itens/${id}${lojaId ? `?lojaId=${lojaId}` : ""}`
    ),

  reorderItems: (payload: {
    itemIds: number[];
    lojaId?: number;
  }): Promise<{ ok: boolean }> =>
    apiClient.put("/controle-producao/itens/reorder", payload),

  getBaseSemanal: (
    data: string,
    lojaId?: number
  ): Promise<BaseSemanalResponse> =>
    apiClient.get(
      `/controle-producao/base-semanal?data=${encodeURIComponent(data)}&matriz=true${
        lojaId ? `&lojaId=${lojaId}` : ""
      }`
    ),

  getHistoricoBaseSemanal: (
    dataSegunda: string,
    lojaId?: number
  ): Promise<BaseSemanalHistoricoResponse> =>
    apiClient.get(
      `/controle-producao/base-semanal/historico?data=${encodeURIComponent(dataSegunda)}${
        lojaId ? `&lojaId=${lojaId}` : ""
      }`
    ),

  replicarBaseSemanalHistorico: (payload: {
    dataSegundaDestino: string;
    dataSegundaOrigem: string;
    lojaId?: number;
  }): Promise<{ ok: boolean; diasReplicados?: number[] }> =>
    apiClient.post(
      "/controle-producao/base-semanal/replicar-historico",
      payload
    ),

  getAlertaBaseSemanal: (
    lojaId?: number,
    opts?: { viaBase?: boolean }
  ): Promise<BaseSemanalAlertaResponse> => {
    const q = lojaId ? `?lojaId=${lojaId}` : "";
    const path = opts?.viaBase
      ? `/controle-producao/base-semanal/alerta${q}`
      : `/controle-producao/ficha-diaria/alerta-base${q}`;
    return opts?.viaBase
      ? apiClient.get(path)
      : apiClient.get(urlFichaSemCache(path), FICHA_NO_STORE);
  },

  saveBaseSemanal: (payload: {
    dataSegunda: string;
    diaSemana: number;
    linhas: { itemId: number; quantidadeBase: string; undMedidaId?: number }[];
    lojaId?: number;
    replicarParaLojaId?: number;
  }): Promise<{
    ok: boolean;
    baseConfirmada?: boolean;
    baseSemanaCompleta?: boolean;
  }> => {
    const body: Record<string, unknown> = {
      dataSegunda: payload.dataSegunda,
      diaSemana: payload.diaSemana,
      linhas: payload.linhas,
    };
    if (payload.lojaId != null && payload.lojaId >= 1) {
      body.lojaId = payload.lojaId;
    }
    if (payload.replicarParaLojaId != null && payload.replicarParaLojaId >= 1) {
      body.replicarParaLojaId = payload.replicarParaLojaId;
    }
    return apiClient.put("/controle-producao/base-semanal", body);
  },

  getFuncionamento: (
    lojaId?: number
  ): Promise<FuncionamentoBaseProducaoResponse> =>
    apiClient.get(
      `/controle-producao/funcionamento${lojaId ? `?lojaId=${lojaId}` : ""}`
    ),

  saveFuncionamento: (payload: {
    lojaId?: number;
    dias: {
      diaSemana: number;
      tipoDia: TipoDiaFuncionamento;
      produzEmBirigui?: boolean;
      turnoDiaInicio?: string;
      turnoDiaTermino?: string;
      turnoNoiteInicio?: string;
      turnoNoiteTermino?: string;
    }[];
  }): Promise<FuncionamentoBaseProducaoResponse> =>
    apiClient.put("/controle-producao/funcionamento", payload),

  saveOrientacaoProducao: async (payload: {
    lojaId?: number;
    texto: string;
    imagensManter: number[];
    novasImagens: File[];
  }): Promise<OrientacaoProducaoData> => {
    const formData = new FormData();
    if (payload.lojaId != null && payload.lojaId >= 1) {
      formData.append("lojaId", String(payload.lojaId));
    }
    formData.append("texto", payload.texto);
    formData.append("imagensManter", JSON.stringify(payload.imagensManter));
    payload.novasImagens.forEach((file) => {
      formData.append("imagens", file);
    });
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${APP_CONFIG.API_URL}/controle-producao/orientacoes`,
      {
        method: "PUT",
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: formData,
      }
    );
    if (!response.ok) {
      let message = "Erro ao salvar orientações.";
      try {
        const data = await response.json();
        const raw = data?.message;
        message = Array.isArray(raw) ? raw[0] : raw || message;
      } catch {
        /* ignore */
      }
      throw new Error(message);
    }
    return response.json();
  },

  getFichaDiaria: (
    data: string,
    lojaId?: number,
    setorId?: number,
    turnoSimulado?: TurnoProducao,
    fichaCompleta?: boolean
  ): Promise<FichaDiariaResponse> =>
    apiClient.get(
      urlFichaSemCache(
        `/controle-producao/ficha-diaria?data=${data}${
          lojaId ? `&lojaId=${lojaId}` : ""
        }${setorId ? `&setorId=${setorId}` : ""}${
          turnoSimulado ? `&turnoSimulado=${turnoSimulado}` : ""
        }${fichaCompleta ? "&fichaCompleta=true" : ""}`
      ),
      FICHA_NO_STORE
    ),

  getUsuariosSetorFicha: (params: {
    setorId: number;
    lojaId?: number;
  }): Promise<FichaDiariaUsuariosSetorResponse> => {
    const qs = new URLSearchParams();
    qs.set("setorId", String(params.setorId));
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    return apiClient.get(
      urlFichaSemCache(
        `/controle-producao/ficha-diaria/usuarios-setor?${qs.toString()}`
      ),
      FICHA_NO_STORE
    );
  },

  saveFichaDiaria: (payload: {
    dataFicha: string;
    linhas: {
      itemId: number;
      sobra?: string;
      undMedidaIdSobra?: number;
      producao?: string;
      undMedidaIdProducao?: number;
      producaoChecada?: boolean;
      naoProduzidoPelaUnidade?: boolean;
      justificativaNaoProduziu?: string;
      observacaoSobra?: string;
      observacaoProducao?: string;
      quantidadeBase?: string;
      undMedidaIdBase?: number;
    }[];
    lojaId?: number;
    setorId?: number;
    turnoSimulado?: TurnoProducao;
  }): Promise<{
    ok: boolean;
    cronometragens?: Array<CronometragemItem & { itemId: number }>;
  }> => apiClient.put("/controle-producao/ficha-diaria", payload),

  assinarProducao: (
    dataFicha: string,
    lojaId?: number,
    setorId?: number,
    turnoSimulado?: TurnoProducao,
    assinaturaImagem?: string
  ): Promise<{ ok: boolean }> =>
    apiClient.post("/controle-producao/ficha-diaria/assinar-producao", {
      dataFicha,
      lojaId,
      setorId,
      ...(turnoSimulado ? { turnoSimulado } : {}),
      ...(assinaturaImagem ? { assinaturaImagem } : {}),
    }),

  assinarProducaoTotal: (
    dataFicha: string,
    lojaId?: number,
    turnoSimulado?: TurnoProducao,
    assinaturaImagem?: string,
    confirmarPendencias?: boolean
  ): Promise<{ ok: boolean }> =>
    apiClient.post("/controle-producao/ficha-diaria/assinar-producao-total", {
      dataFicha,
      lojaId,
      ...(turnoSimulado ? { turnoSimulado } : {}),
      ...(assinaturaImagem ? { assinaturaImagem } : {}),
      ...(confirmarPendencias ? { confirmarPendencias: true } : {}),
    }),

  assinarConferencia: (
    dataFicha: string,
    lojaId?: number,
    justificativaSemSobra?: string,
    turnoSimulado?: TurnoProducao,
    assinaturaImagem?: string
  ): Promise<{ ok: boolean }> =>
    apiClient.post("/controle-producao/ficha-diaria/assinar-conferencia", {
      dataFicha,
      lojaId,
      ...(justificativaSemSobra?.trim()
        ? { justificativaSemSobra: justificativaSemSobra.trim() }
        : {}),
      ...(turnoSimulado ? { turnoSimulado } : {}),
      ...(assinaturaImagem ? { assinaturaImagem } : {}),
    }),

  getRelatorioConsumo: (params: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number;
    agrupamento?: AgrupamentoRelatorioConsumo;
    margemCompraPercent?: number;
  }): Promise<RelatorioConsumoResponse> => {
    const qs = new URLSearchParams();
    qs.set("dataInicio", params.dataInicio);
    qs.set("dataFim", params.dataFim);
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    if (params.agrupamento) qs.set("agrupamento", params.agrupamento);
    if (params.margemCompraPercent != null) {
      qs.set("margemCompraPercent", String(params.margemCompraPercent));
    }
    return apiClient.get(
      `/controle-producao/relatorio-consumo?${qs.toString()}`
    );
  },

  getPainelSobras: (params: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number;
  }): Promise<PainelSobrasResponse> => {
    const qs = new URLSearchParams();
    qs.set("dataInicio", params.dataInicio);
    qs.set("dataFim", params.dataFim);
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    return apiClient.get(`/controle-producao/sobras?${qs.toString()}`);
  },

  listSetores: (lojaId?: number): Promise<SetorProducao[]> =>
    apiClient.get(
      `/controle-producao/setores${lojaId ? `?lojaId=${lojaId}` : ""}`
    ),

  createSetor: (payload: {
    nome: string;
    lojaId: number;
  }): Promise<SetorProducao> =>
    apiClient.post("/controle-producao/setores", payload),

  updateSetor: (
    id: number,
    payload: { nome?: string; ativo?: boolean; lojaId?: number }
  ): Promise<SetorProducao> =>
    apiClient.put(`/controle-producao/setores/${id}`, payload),

  deleteSetor: (id: number): Promise<void> =>
    apiClient.delete(`/controle-producao/setores/${id}`),

  acionarCronometro: (
    acao: "iniciar" | "pausar" | "retomar" | "encerrar",
    payload: {
      dataFicha: string;
      setorId?: number;
      itemId: number;
      lojaId?: number;
      justificativa?: string;
      turnoSimulado?: TurnoProducao;
    }
  ): Promise<CronometragemItem> =>
    apiClient.post(
      `/controle-producao/ficha-diaria/cronometro/${acao}`,
      payload
    ),

  listarPausasFicha: (params: {
    data: string;
    lojaId?: number;
    setorId?: number;
  }): Promise<PausaFichaItem[]> => {
    const qs = new URLSearchParams();
    qs.set("data", params.data);
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    if (params.setorId) qs.set("setorId", String(params.setorId));
    return apiClient.get(
      urlFichaSemCache(
        `/controle-producao/ficha-diaria/pausas?${qs.toString()}`
      ),
      FICHA_NO_STORE
    );
  },

  listarPausasPeriodo: (params: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number;
  }): Promise<PausaPeriodoItem[]> => {
    const qs = new URLSearchParams();
    qs.set("dataInicio", params.dataInicio);
    qs.set("dataFim", params.dataFim);
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    return apiClient.get(`/controle-producao/pausas-periodo?${qs.toString()}`);
  },

  getRelatorioTempos: (params: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number;
    agrupamento?: AgrupamentoRelatorioConsumo;
  }): Promise<RelatorioTemposResponse> => {
    const qs = new URLSearchParams();
    qs.set("dataInicio", params.dataInicio);
    qs.set("dataFim", params.dataFim);
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    if (params.agrupamento) qs.set("agrupamento", params.agrupamento);
    return apiClient.get(
      `/controle-producao/relatorio-tempos?${qs.toString()}`
    );
  },

  getRelatorioAssinaturasProducao: (params: {
    dataInicio: string;
    dataFim: string;
    lojaId?: number;
  }): Promise<RelatorioAssinaturasProducaoResponse> => {
    const qs = new URLSearchParams();
    qs.set("dataInicio", params.dataInicio);
    qs.set("dataFim", params.dataFim);
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    return apiClient.get(
      `/controle-producao/relatorio-assinaturas-producao?${qs.toString()}`
    );
  },

  getRelatorioEquipe: (params: {
    lojaId?: number;
  }): Promise<RelatorioEquipeResponse> => {
    const qs = new URLSearchParams();
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return apiClient.get(`/controle-producao/relatorio-equipe${suffix}`);
  },

  getRankingDiaFicha: (params: {
    lojaId?: number;
  }): Promise<RankingDiaFichaResponse> => {
    const qs = new URLSearchParams();
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return apiClient.get(
      urlFichaSemCache(`/controle-producao/ranking-dia${suffix}`),
      FICHA_NO_STORE
    );
  },

  getRankingSetores: (params: {
    lojaId?: number;
  }): Promise<RankingSetoresResponse> => {
    const qs = new URLSearchParams();
    if (params.lojaId) qs.set("lojaId", String(params.lojaId));
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return apiClient.get(
      urlFichaSemCache(`/controle-producao/ranking-setores${suffix}`),
      FICHA_NO_STORE
    );
  },
};
